import React, {memo} from 'react';
import {Col} from "react-bootstrap";

function PasswordRuleSetComponent() {
    return (
        <>
            <Col>
                <p className="handwai-text-label-main">Passwort Regeln</p>
                <h6 className="h-text">
                    <div className="p-toggle pretty p-icon p-round p-locked p-jelly">
                        <input type="checkbox" id="c1"/>
                        <div className="state p-success p-on"><i
                            style={dotOnStyle} className="icon mdi mdi-check"/><label/>
                        </div>
                        <div className="state p-danger p-off"><i
                            style={dotOffStyle} className="icon mdi mdi-check"/><label/>
                        </div>
                    </div>
                    Mindestlänge 8 Zeichen & maximale Länge 50 Zeichen
                </h6>
                <h6 className="h-text">
                    <div className="p-toggle pretty p-icon p-round p-locked p-jelly">
                        <input type="checkbox" id="c2"/>
                        <div className="state p-success p-on"><i
                            style={dotOnStyle} className="icon mdi mdi-check"/><label/>
                        </div>
                        <div className="state p-danger p-off"><i
                            style={dotOffStyle} className="icon mdi mdi-check"/><label/>
                        </div>
                    </div>
                    Mindestens 1 Großbuchstabe
                </h6>
                <h6 className="h-text">
                    <div className="p-toggle pretty p-icon p-round p-locked p-jelly">
                        <input type="checkbox" id="c3"/>
                        <div className="state p-success p-on"><i
                            style={dotOnStyle} className="icon mdi mdi-check"/><label/>
                        </div>
                        <div className="state p-danger p-off"><i
                            style={dotOffStyle} className="icon mdi mdi-check"/><label/>
                        </div>
                    </div>
                    Mindestens 1 Sonderzeichen
                </h6>
                <h6 className="h-text">
                    <div className="p-toggle pretty p-icon p-round p-locked p-jelly">
                        <input type="checkbox" id="c4"/>
                        <div className="state p-success p-on"><i
                            style={dotOnStyle} className="icon mdi mdi-check"/><label/>
                        </div>
                        <div className="state p-danger p-off"><i
                            style={dotOffStyle} className="icon mdi mdi-check"/><label/>
                        </div>
                    </div>
                    Mindestens 1 Ziffer (0-9)
                </h6>
                <h6 className="h-text">
                    <div className="p-toggle pretty p-icon p-round p-locked p-jelly">
                        <input type="checkbox" id="c5"/>
                        <div className="state p-success p-on"><i
                            style={dotOnStyle} className="icon mdi mdi-check"/><label/>
                        </div>
                        <div className="state p-danger p-off"><i
                            style={dotOffStyle} className="icon mdi mdi-check"/><label/>
                        </div>
                    </div>
                    Beide Passwörter müssen übereinstimmen
                </h6>
            </Col>
        </>
    )
}

const dotOnStyle = {
    backgroundColor: 'var(--handwai-green-color)'
}

const dotOffStyle = {
    backgroundColor: 'var(--handwai-red-color)'
}

export default memo(PasswordRuleSetComponent);